"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_query_1 = require("react-query");
var api_1 = require("../../../api");
var crumb_nav_1 = __importDefault(require("../../../components/crumb_nav"));
var inline_loader_1 = __importDefault(require("../../../components/inline_loader"));
var get_orders_1 = require("../../../queries/get-orders");
var order_card_1 = __importDefault(require("../components/order-card"));
exports.default = (function (_a) {
    var isLoadingAccountData = _a.isLoadingAccountData;
    var _b = (0, react_query_1.useQuery)('GetOrders', function () { return (0, api_1.getSubscriptionAPIClient)().request(get_orders_1.GetOrders); }), data = _b.data, isLoading = _b.isLoading;
    var crumbNavHeader = React.createElement(crumb_nav_1.default, { current: 'Viewing Past Orders' });
    if (isLoadingAccountData) {
        // case for when loading orders page directly (/account#/orders)
        // make sure we only have one loader. account data is needed before showing crumbNav for back button functionality
        return React.createElement(React.Fragment, null);
    }
    if (isLoading) {
        return React.createElement(inline_loader_1.default, { isLoading: isLoading });
    }
    if (!data) {
        return (React.createElement("div", null,
            crumbNavHeader,
            React.createElement("div", null, "error")));
    }
    var ordersData = data.getOrders;
    if (!ordersData) {
        return React.createElement("div", null, "No orders to display");
    }
    return (React.createElement("div", null,
        crumbNavHeader,
        ordersData.map(function (order) { return (React.createElement("div", { className: 'margin-bottom-1', key: order.id },
            React.createElement(order_card_1.default, { order: order }))); })));
});
